import React, { useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "./../../../../../../../../assets/css/Dashboard/Claim.scss";
import CPCSIcon from "../../../../../ServicesIcons/nhs.svg";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { showError } from "../../../../../../../../components/ToastedMessage/ToastedMessage";
import {
  getAnalyticsServicesCompletedClaimed,
  getAnalyticsServicesCompletedToBeClaimed,
  getAnalyticsServicesDeclined,
  updateClaimStatus,
} from "../../../../../../../../dispatchers/pharmacyServiceDispatchers";
import useTitanApp from "../../../../../../../../hooks/useTitanApp";
import OrbitCheckFilter from "./OrbitCheckFilter";
import CustomOrbitCheckFilter from "./CustomOrbitCheckFilter";
import ToBeClaimedSkeletonLoader from "./TobeClaimedSkeletonLoader";
import { json } from "zod";
import { createNmsClaim } from "../../../../../../../../dispatchers/mysClaimsDispatcher";

export default function TobeClaimed(props) {
  const filteredServices = React.useMemo(() => {
    let updatedFilteredServices = props.unclaimedServices;
    if (props.filterType === "3") {
      updatedFilteredServices = updatedFilteredServices.filter(
        (service) => service.status !== 3,
      );
    }
    return updatedFilteredServices;
  }, [props.unclaimedServices, props.filterType]);
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const [rowData, setRowData] = useState([]);

  const PatientColumns = [
    {
      field: "selected",
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      checkboxSelection: true,
      onCheckboxValueChanged: onCheckboxValueChanged,
      width: 50,
      selected: false,
      filter: false,
      floatingFilter: false,
    },
    {
      headerName: "Patient name",
      field: "patientName",
      sortable: true,
      editable: false,
      selected: false,
    },
    {
      headerName: "Telephone Number",
      field: "telephoneNumber",
      sortable: true,
      editable: false,
      selected: false,
    },
    {
      headerName: "Date of Birth",
      field: "dob",
      sortable: true,
      editable: false,
      selected: false,
      valueFormatter: (params) => {
        if (params.value && params.value !== "0001-01-01T00:00:00Z") {
          const date = new Date(params.value);
          return date.toLocaleDateString("en-GB");
        } else {
          return "-";
        }
      },
      filterValueGetter: (params) => {
        if (params.data?.dob && params.data.dob !== "0001-01-01T00:00:00Z") {
          return new Date(params.data.dob).toLocaleDateString("en-GB");
        }
        return "-";
      },
    },
    {
      headerName: "Service Name",
      field: "serviceName",
      sortable: true,
      editable: false,
      selected: false,
    },
    {
      headerName: "Drug Name",
      field: "drugName",
      sortable: true,
      editable: false,
      selected: false,
    },
    {
      headerName: "Completed By",
      field: "completedBy",
      sortable: true,
      editable: false,
      selected: false,
    },
    {
      headerName: "Engagement Date",
      field: "engagementDate",
      sortable: true,
      editable: false,
      selected: false,
      hide: true,
      valueFormatter: (params) => {
        if (params.value !== null) {
          const date = new Date(params.value);
          const options = { day: "2-digit", month: "2-digit", year: "numeric" };
          return date.toLocaleDateString("en-GB", options);
        } else {
          return "-";
        }
      },
    },
    {
      headerName: "Intervention Date",
      field: "interventionDate",
      sortable: true,
      editable: false,
      selected: false,
      hide: true,
      valueFormatter: (params) => {
        if (params.data?.stageType === 3 && params.value) {
          const date = new Date(params.value);
          const options = { day: "2-digit", month: "2-digit", year: "numeric" };
          return date.toLocaleDateString("en-GB", options);
        } else {
          return "-";
        }
      },
    },
    {
      headerName: "FollowUp Date",
      field: "followUpDate",
      sortable: true,
      editable: false,
      selected: false,
      hide: true,
      valueFormatter: (params) => {
        if (params.data?.stageType === 4 && params.value) {
          const date = new Date(params.value);
          const options = { day: "2-digit", month: "2-digit", year: "numeric" };
          return date.toLocaleDateString("en-GB", options);
        } else {
          return "-";
        }
      },
    },
    {
      headerName: "Completed On",
      field: "createdOn",
      sortable: true,
      editable: false,
      selected: false,
      valueFormatter: (params) => {
        if (params.value !== null) {
          const date = new Date(params.value);
          const options = { day: "2-digit", month: "2-digit", year: "numeric" };
          return date.toLocaleDateString("en-GB", options);
        } else {
          return "-";
        }
      },
      filterValueGetter: (params) => {
        if (
          params.data?.createdOn !== null &&
          params.data?.createdOn !== undefined
        ) {
          const options = {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          } as const;
          return new Date(params.data.createdOn).toLocaleDateString(
            "en-GB",
            options,
          );
        }
        return "-";
      },
    },
    {
      headerName: "Stage",
      field: "stageType",
      sortable: true,
      editable: false,
      valueGetter: (params) => {
        switch (params.data.stageType) {
          case 3:
            return "Intervention";
          case 4:
            return "Followup";
          default:
            return "Intervention";
        }
      },
    },
    {
      headerName: "NHS Number",
      field: "nhsNumber",
      sortable: true,
      editable: false,
      selected: false,
    },
    {
      headerName: "Address",
      field: "address",
      sortable: true,
      editable: false,
      selected: false,
    },
  ].map((col) => {
    if (
      col.field &&
      !col.valueFormatter &&
      !col.cellRenderer &&
      col.field !== "selected"
    ) {
      return {
        ...col,
        valueFormatter: (params) =>
          params.value === null ||
          params.value === undefined ||
          params.value === ""
            ? "-"
            : params.value,
      };
    }
    return col;
  });

  const { appState, pharmacyServiceState } = useTitanApp();
  const { currentPharmacyId } = appState || {};
  const {
    currentServiceId,
    isPharmacyServiceCompletedTobeClaimedLoading,
    serviceAnalyticsCompletedTobeClaimed,
    pharmacyServices,
  } = pharmacyServiceState || {};

  function onCheckboxValueChanged(params) {
    const selectedNodes = params?.api?.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node?.data);
    const updatedData = selectedData?.map((item) => item?._id);
    setRowData(updatedData);
  }
  const gridOptions = {
    suppressMovableColumns: true,
    getRowClass: (params) => (params.node.isSelected ? "selected-row" : ""),
    onRowClicked: (event) => {
      if (props.onRowClick) {
        props.onRowClick(event.data);
      }
    },
  };
  const exportToCSV = (apiData, fileName) => {
    const modifiedData = apiData?.map((item) => {
      const statusMap = {
        0: "Pending",
        1: "Progress",
        2: "Completed",
        3: "Decline",
      };
      const stage = {
        3: "Intervention",
        4: "Followup",
      };

      return {
        "Patient Name": item.patientName || "-",
        "Telephone Number": item.telephoneNumber || "-",
        "Date of Birth": item.dob
          ? new Date(item.dob).toLocaleDateString("en-GB")
          : "-",
        "Service Name": item.serviceName || "-",
        "Drug Name": item.drugName ? `${item.drugName}` : "-",
        "Completed By": item.completedBy || "-",
        "Completed On": item.createdOn
          ? new Date(item.createdOn).toLocaleDateString("en-GB")
          : "-",
        Stage: stage[item.stageType] ?? "-",
        "NHS Number": item.nhsNumber || "-",
        Address: item.address || "-",
      };
    });

    const ws = XLSX.utils.json_to_sheet(modifiedData);
    const wb = {
      Sheets: { ["To be Claimed"]: ws },
      SheetNames: ["To be Claimed"],
    };
    const csv = XLSX.utils.sheet_to_csv(ws);
    const csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    FileSaver.saveAs(csvData, `${fileName}.csv`);
    // const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    // const data = new Blob([excelBuffer], { type: fileType });
    // FileSaver.saveAs(data, fileName + fileExtension);
  };
  async function createClaim() {
    const selectedServices = rowData
      .map((item) => {
        return serviceAnalyticsCompletedTobeClaimed.find(
          (service) => service._id?.toString() === item?.toString(),
        );
      })
      .filter(Boolean);

    const payload = selectedServices.map((x) => ({
      clinicalServiceId: x.clinicalServiceID,
      pharmacyId: x.pharmacyID || "",
      patient: {
        nhsNumber: x.nhsNumber || "",
      },
      yearMonth: new Date().toISOString().slice(0, 7),
      referralDate: x.engagementDate,
      referrerOrgType: 1,
      referrerCaseReference: "AA4G-BB23-HH78",
      assessmentDate: x.completedAt,
      professionalRole: 1, // ProfessionalRoles: 1 = PHARMACIST, 2 = PHARMACY_TECHNICIAN

      serviceType:
        x.stageType === 3 ? x.stageType : x.stageType === 4 ? x.stageType : 3,
      // ServiceTypes: 1 = ENGAGEMENT, 2 = INTERVENTION, 3 = FOLLOW_UP

      nonProvisionOfServiceReason: 1, // NonProvisionOfServiceReasons: 1 = DECLINED, 2 = DID_NOT_ATTEND

      conditions: [1, 2], // Conditions: 1 = ASTHMA, 2 = CHRONIC_OBSTRUCTIVE_PULMONARY_DISEASE, 3 = DIABETES_TYPE_2, 4 = HYPERTENSION, 5 = HYPERCHOLESTEROLAEMIA, 6 = OSTEOPOROSIS, 7 = GOUT, 8 = GLAUCOMA, 9 = EPILEPSY, 10 = PARKINSONS_DISEASE, 11 = URINARY_INCONTINENCE_RETENTION, 12 = HEART_FAILURE, 13 = ACUTE_CORONARY_SYNDROMES, 14 = ATRIAL_FIBRILLATION, 15 = LONG_TERM_RISKS_OF_VENOUS_THROMBOEMBOLISM_EMBOLISM, 16 = STROKE_TRANSIENT_ISCHEMIC_ATTACK, 17 = CORONARY_HEART_DISEASE, 18 = DEPRESSION

      notUsingPrescribeMedicineReason: [1, 2], // NotUsingMedicineReasons: 1 = PATIENT_NOT_STARTED_MEDICINE, 2 = PRESCRIBER_STOP_NEW_MEDICINE, 3 = PATIENT_MEDICINE_NOT_IN_LINE

      consultationMethod: 3, // ConsultationMethods: 1 = FTF_PHARMACY, 2 = FTF_PATIENT_HOME, 3 = TELEPHONE, 4 = TELEMEDICINE

      consultationOutcome: 1, // FollowUpConsultationOutcomes: 1 = NO_ACTION, 2 = PHARMACIST_PATIENT_AGREE, 3 = REFFERAL_TO_GP, 4 = REFFERAL_TO_OTHER_PRESC_ORG

      products: (x.drugName || []).map((d) => ({
        snomedCode: "123456",
        medicationName: d.trim(),
      })),
      signpostedTo: 2, // SignpostedTos: 1 = GP, 2 = OTHER

      referredOrgOds: "",
    }));
    await createNmsClaim(payload);
  }

  async function sentClaim() {
    const data = await updateClaimStatus(rowData);
    if (data) {
      getAnalyticsServicesCompletedClaimed(currentPharmacyId, currentServiceId);
      getAnalyticsServicesCompletedToBeClaimed(
        currentPharmacyId,
        currentServiceId,
        "1",
      );
      getAnalyticsServicesDeclined(currentPharmacyId, currentServiceId);
    } else {
      showError("Error sending to claim", true, false);
    }
  }

  return (
    <div
      className={`${
        props.darkMode === true ? "ag-theme-alpine-dark" : "ag-theme-alpine"
      }`}
    >
      {isPharmacyServiceCompletedTobeClaimedLoading ? (
        <ToBeClaimedSkeletonLoader />
      ) : props?.unclaimedServices?.length !== 0 ? (
        <>
          <div
            style={{
              height: "500px",
            }}
          >
            <AgGridReact
              rowData={filteredServices}
              columnDefs={PatientColumns}
              gridOptions={gridOptions}
              onSelectionChanged={onCheckboxValueChanged}
              rowSelection="multiple"
              suppressRowTransform={true}
              suppressServerSideFullWidthLoadingRow={true}
              reactiveCustomComponents
              defaultColDef={{
                sortable: true,
                floatingFilter: true, // enable search bar under headers
                resizable: true,
                filter: "agTextColumnFilter", // basic text filter
                floatingFilterComponentParams: { suppressFilterButton: true }, // hides funnel icon
              }}
            />
          </div>
          <div className="analytics_tab_list_footer">
            {rowData?.length > 0 && (
              <button
                onClick={async () => {
                  // await createClaim();
                  await sentClaim();
                }}
              >
                <span>Mark as claimed</span>
                <span>
                  <CPCSIcon />
                </span>
              </button>
            )}
            <button
              onClick={(e) => exportToCSV(filteredServices, "ToBeClaimedFile")}
            >
              <p>Export</p>
            </button>
          </div>
        </>
      ) : (
        <div>
          <h4>No Data To Show</h4>
        </div>
      )}
    </div>
  );
}
